import {loadable} from "jotai/utils";
import {atomWithRefresh} from "../utils/jotaiUtils";
import {routerCompanyIdAtom} from "./routerStore";
import {getCompanyResultsSignedUrl} from "../services/resultsService";

export const activeCompanyResultsSignedUrlAtom = atomWithRefresh(async (get) => {
    const activeCompanyId = get(routerCompanyIdAtom);
    const url = activeCompanyId !== undefined ? await getCompanyResultsSignedUrl(activeCompanyId) : "";
    return url;
});

export const activeCompanyResultsSignedUrlLoadable = loadable(activeCompanyResultsSignedUrlAtom);
